import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Black } from 'wobi-web-common/dist/Colors';

const styles = {
  content: { textAlign: 'center', p: 4 },
  iconWrapper: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    bgcolor: 'success.light',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mx: 'auto',
    mb: 2,
  },
  title: (theme) => ({
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
    color: 'secondary.main',
    mb: 1,
  }),
  description: (theme) => ({
    fontSize: theme.typography.pxToRem(14),
    color: Black[300],
    lineHeight: 1.6,
  }),
};

/**
 * Generic confirmation popup — icon/title/description centered dialog.
 * Reuses the app-wide MuiDialog theme override for the rounded, shadowless paper.
 */
const SuccessPopup = ({ open, onClose, title, description }) => (
  <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
    <Box sx={styles.content}>
      <Box sx={styles.iconWrapper}>
        <CheckCircleIcon sx={{ fontSize: 44, color: 'success.main' }} />
      </Box>
      <Typography sx={styles.title}>{title}</Typography>
      <Typography sx={styles.description}>{description}</Typography>
    </Box>
  </Dialog>
);

SuccessPopup.propTypes = {
  description: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default SuccessPopup;
